export const USER_LOGIN="USER_LOGIN";
export const AUTH="AUTH";
export const ALL_USERS="ALL_USERS";
export const USER="USER";
export const REDIRECT = "REDIRECT";
export const COLLECTIONS = "COLLECTIONS"